import {getMethod} from '~/api'

async function get(link) {
    return await getMethod(`/cms/resorts/${link}`)
}

export {get}
